import { CSSProperties } from 'react';
import styled from 'styled-components';
import MarkdownBase, { Options } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {
  fontFamily,
  fontSize,
  lineHeight,
  radius,
  space,
} from '../../style/utils';

interface MarkdownProps extends Options {
  dir?: 'auto' | 'ltr' | 'rtl';
  style?: CSSProperties;
}

const MarkdownStyled = styled(MarkdownBase)<{ $fontSize?: string }>`
  font-size: ${({ $fontSize }) => $fontSize || fontSize('base')};
  color: ${({ theme }) => theme.palette.content.primary};

  p {
    margin: 0;
    line-height: ${lineHeight('relaxed')};
  }

  a {
    color: ${({ theme }) => theme.palette.accent.link};
  }

  ul,
  ol {
    line-height: ${lineHeight('relaxed')};
  }

  code {
    font-family: ${fontFamily('mono')};
    background: ${({ theme }) => theme.palette.surface.strong};
    color: ${({ theme }) => theme.palette.content.muted};
    padding: ${space(0, 'xs')};
    border-radius: ${radius('xxs')};
    white-space: pre-wrap;
  }
`;

const Markdown = (props: MarkdownProps) => (
  <MarkdownStyled {...props} remarkPlugins={[remarkGfm]} />
);

export default Markdown;
